import * as information from '@core/store/actions/information.actions';
import * as loginMessages from '@core/store/actions/login-messages.actions';
import * as userLoginMessages from '@core/store/actions/user-login-messages.actions';
import * as userInformation from '@core/store/actions/user-information.actions';
import * as forms from '@core/store/actions/forms.actions';
import * as feed from '@core/store/actions/feed.actions';

export * from '@core/store/actions/information.actions';
export * from '@core/store/actions/login-messages.actions';
export * from '@core/store/actions/user-login-messages.actions';
export * from '@core/store/actions/user-information.actions';
export * from '@core/store/actions/forms.actions';
export * from '@core/store/actions/feed.actions';

export const ActionTypes = {
  ...information.InformationActionTypes,
  ...loginMessages.LoginMessagesActionTypes,
  ...userLoginMessages.UserLoginMessagesActionTypes,
  ...userInformation.UserInformationActionTypes,
  ...forms.FormsActionTypes,
  ...feed.FeedActionTypes
};

export type Actions =
  | information.InformationActions
  | loginMessages.LoginMessagesActions
  | userLoginMessages.UserLoginMessagesActions
  | userInformation.UserInformationActions
  | forms.FormsActions
  | feed.FeedActions;
